import { render, staticRenderFns } from "./catalog-used.vue?vue&type=template&id=516f535e"
import script from "./catalog-used.vue?vue&type=script&lang=js"
export * from "./catalog-used.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogMarks: require('/var/www/components/catalog/catalog-marks.vue').default,CatalogSubFilters: require('/var/www/components/catalog/catalog-sub-filters.vue').default,FilterDesktop: require('/var/www/components/filter/filter-desktop.vue').default,FilterSort: require('/var/www/components/filter/filter-sort.vue').default})
